// extracted by mini-css-extract-plugin
module.exports = {"top":"UsersTable_top__HFbzG","rightSide":"UsersTable_rightSide__3nV7v"};